export default __webpack_public_path__ + "static/media/character-hidehisha.f32db036.png";